import '../scss/style.scss';

window.$ = window.jQuery = require('jquery');
window.Popper = require('@popperjs/core/lib/popper.js');
window.lightbox = require('./lightbox.js');
window.bootstrap = require('bootstrap/dist/js/bootstrap');

// Scripts
require('./smooth-scroll.js');
require('./preloading.js');
require('./scrollbar.js');
require('./slick-slider.js');
require('./menu.js');
require('./menu-mobile.js');
require('./sticky-header.js');
require('./speakers-slider.js');
require('./speaker-modal.js');
require('./keynote-modal.js');
require('./contact-form-modal.js');
require('./workshops-slider.js');
require('./schedule.js');
require('./gallery-slider.js');
require('./event-modal.js');